import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceString',
})
export class ReplaceStringPipe implements PipeTransform {
  transform(value: string, variableValue: string, replaceValue: number): any {
    if (value) {
      const replace = (+replaceValue).toString();
      return value.replace(variableValue, replace);
    }
    return '';
  }
}
